import axios from 'axios';
import _ from 'lodash';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { change, initialize } from 'redux-form';
import types from './type';

const STATIONS_JOURNEYS = `${BASE_API}/journeys-station`;
const JOURNEYS = `${BASE_API}/journeys`;
const LEVELS = `${BASE_API}/level`;
const ACTIONS = `${BASE_API}/avaliable-actions`;
const ACTION_JOURNEY_ONLY = `${BASE_API}/actions`;

export const clearJourneyOnly = (actionId) => {
  return (dispatch) =>
    axios
      .put(
        `${ACTION_JOURNEY_ONLY}/${actionId}/journey-only`,
        { journey_only: false },
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .catch((e) => {
        dispatch({
          type: 'SNACKBAR',
          payload: {
            message:
              _.get(e, 'response.data.messages[0]') ||
              'A atividade saiu da jornada, mas continua marcada como exclusiva. Desmarque no formulário dela.',
            variant: 'error',
            open: true,
          },
        });
      });
};

export const getStationJourneys = (id) => {
  return (dispatch) => {
    dispatch([
      {
        type: types.JOURNEYS_LOAD,
        payload: true,
      },
    ]);
    axios
      .get(`${STATIONS_JOURNEYS}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.JOURNEYS_FETCHED,
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch([
          {
            type: types.JOURNEYS_LOAD,
            payload: false,
          },
        ]);
        try {
          if (e.response.data[0]) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `Erro: ${e.response.data[0]}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};

export const getDetail = (id) => {
  return (dispatch) => {
    dispatch([
      {
        type: types.JOURNEYS_DETAIL_LOAD,
        payload: true,
      },
    ]);
    axios
      .get(`${JOURNEYS}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const { data } = response;

        const tempLevels = [];
        for (const level of data.levels) {
          const tempLevel = {
            id: level.id,
            journey_level_id: level.journey_level_id,
            actions: level.journey_actions.length === 0 ? [{ required: true }] : [],
          };
          for (const action of level.journey_actions) {
            tempLevel.actions.push({
              createdAt: action.createdAt,
              action_id: action.action_id,
              required: action.required,
            });
          }
          tempLevels.push(tempLevel);
        }

        const initialValues = {
          journey_id: data.id,
          journey_name: data.name,
          start: data.start,
          end: data.end,
          priority: data.priority,
          levels: tempLevels,
        };

        dispatch([
          {
            type: types.JOURNEYS_DETAIL_FETCHED,
            payload: response.data,
          },
          initializeForm(initialValues),
        ]);
      })
      .catch((e) => {
        dispatch([
          {
            type: types.JOURNEYS_DETAIL_LOAD,
            payload: false,
          },
        ]);
        try {
          if (e.response.data[0]) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `Erro: ${e.response.data[0]}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};

export const initializeForm = (values) => {
  return initialize('journeysForm', values);
};

export const startNewJourney = () => {
  return (dispatch) => {
    dispatch([
      {
        type: types.JOURNEYS_DETAIL_LOAD,
        payload: false,
      },
      initializeForm({
        priority: 1,
        levels: [{ actions: [{ required: true }] }],
      }),
    ]);
  };
};

const prepareLevels = (values) => {
  const levels = (values.levels || []).map((level) => (level ? { ...level } : level));

  for (const level of levels) {
    if (!level || !level.actions || level.actions.length === 0) {
      return null;
    }
    for (const action of level.actions) {
      if (!action || !action.action_id) {
        return null;
      }
    }
  }

  if (levels.length > 0) {
    levels[0].journey_level_id = null;
    for (let i = 1; i < levels.length; i++) {
      if (levels[i - 1].id) {
        levels[i].journey_level_id = levels[i - 1].id;
      }
    }
  }

  return levels;
};

const niveisSemAtividade = () => ({
  type: 'SNACKBAR',
  payload: {
    message: `Erro: todos os níveis precisam ter atividades selecionadas`,
    variant: 'error',
    open: true,
  },
});

export const createJourneyWithValues = (station_id, values, router) => {
  return (dispatch, getState) => {
    if (!prepareLevels(values)) {
      dispatch([niveisSemAtividade()]);
      return;
    }
    if (getState().journeys.buttonLoading) {
      return;
    }

    dispatch([
      {
        type: types.JOURNEYS_BUTTON_LOADING,
        payload: true,
      },
    ]);
    axios
      .post(
        `${JOURNEYS}`,
        { station_id },
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        const journeyId = response.data.createJourney.id;
        const emptyLevel = response.data.createRandomLevel;
        const levels = (values.levels || []).map((level, index) =>
          index === 0 && emptyLevel && level && !level.id ? { ...level, id: emptyLevel.id } : level
        );

        dispatch([change('journeysForm', 'journey_id', journeyId)]);
        if (emptyLevel && levels[0] && levels[0].id === emptyLevel.id) {
          dispatch([change('journeysForm', 'levels[0].id', emptyLevel.id)]);
        }
        dispatch(updateJourney(journeyId, { ...values, journey_id: journeyId, levels }, router));
      })
      .catch((e) => {
        dispatch([
          {
            type: types.JOURNEYS_BUTTON_LOADING,
            payload: false,
          },
        ]);
        try {
          if (e.response.data[0]) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `Erro: ${e.response.data[0]}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};

export const updateJourney = (id, values, router, redirect = true) => {
  return (dispatch) => {
    dispatch([
      {
        type: types.JOURNEYS_BUTTON_LOADING,
        payload: true,
      },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);
    const levels = prepareLevels(values);

    if (levels) {
      const newValues = { ...values, levels };

      axios
        .put(`${JOURNEYS}/${id}`, newValues, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
          onUploadProgress: (progressEvent) =>
            dispatch([
              {
                type: 'SUBMIT_PROGRESS',
                payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
              },
            ]),
        })
        .then(() => {
          dispatch([
            {
              type: types.JOURNEYS_BUTTON_LOADING,
              payload: false,
            },
            {
              type: 'SUBMIT_PROGRESS',
              payload: 0,
            },
          ]);
          if (redirect) {
            router.push(`/owner/journeys`);
          }
        })
        .catch((e) => {
          dispatch([
            {
              type: types.JOURNEYS_BUTTON_LOADING,
              payload: false,
            },
            {
              type: 'SUBMIT_PROGRESS',
              payload: 0,
            },
          ]);
          try {
            const data = e.response.data;
            const message = Array.isArray(data)
              ? data[0]
              : data.messages
              ? data.messages[0]
              : data[0];
            if (message) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `Erro: ${message}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          } catch (error) {
            dispatch({
              type: 'SNACKBAR',
              payload: { message: 'Erro', variant: 'error', open: true },
            });
          }
        });
    } else {
      dispatch([
        niveisSemAtividade(),
        {
          type: types.JOURNEYS_BUTTON_LOADING,
          payload: false,
        },
        {
          type: 'SUBMIT_PROGRESS',
          payload: 0,
        },
      ]);
    }
  };
};

export const deleteLevel = (id) => {
  return (dispatch) => {
    dispatch([
      {
        type: types.JOURNEYS_BUTTON_LOADING,
        payload: true,
      },
    ]);
    axios
      .delete(`${LEVELS}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.JOURNEYS_BUTTON_LOADING,
            payload: false,
          },
        ]);
      })
      .catch((e) => {
        dispatch([
          {
            type: types.JOURNEYS_BUTTON_LOADING,
            payload: false,
          },
        ]);
        try {
          if (e.response.data[0]) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `Erro: ${e.response.data[0]}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};

export const getAvailableActions = (id, journey_id) => {
  return (dispatch) => {
    dispatch([
      {
        type: types.ACTIONS_LOAD,
        payload: true,
      },
    ]);
    axios
      .get(`${ACTIONS}/?where[station_id]=${id}&&where[journey_id]=${journey_id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.ACTIONS_FETCHED,
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch([
          {
            type: types.ACTIONS_LOAD,
            payload: false,
          },
        ]);
        try {
          if (e.response.data[0]) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `Erro: ${e.response.data[0]}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};

export const deleteJourney = (journey_id, station_id, setOpen) => {
  return (dispatch) => {
    dispatch([
      {
        type: types.JOURNEYS_BUTTON_LOADING,
        payload: true,
      },
    ]);
    axios
      .delete(`${JOURNEYS}/${journey_id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.JOURNEYS_BUTTON_LOADING,
            payload: false,
          },
          getStationJourneys(station_id),
          setOpen(false),
        ]);
      })
      .catch((e) => {
        dispatch([
          {
            type: types.JOURNEYS_BUTTON_LOADING,
            payload: false,
          },
        ]);
        try {
          if (e.response.data[0]) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `Erro: ${e.response.data[0]}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};

export const getJourneyRanking = (id) => {
  return (dispatch) => {
    dispatch([
      {
        type: types.RANKING_FETCHED,
        payload: null,
      },
      {
        type: types.RANKING_LOAD,
        payload: true,
      },
    ]);
    axios
      .get(`${JOURNEYS}/${id}/ranking?size=100`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.RANKING_FETCHED,
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch([
          {
            type: types.RANKING_ERROR,
            payload: true,
          },
        ]);
        dispatch({
          type: 'SNACKBAR',
          payload: {
            message: 'Não foi possível carregar o rank da jornada',
            variant: 'error',
            open: true,
          },
        });
      });
  };
};

export const getJourneyReport = (id) => {
  return (dispatch) => {
    dispatch([
      {
        type: types.REPORT_LOAD,
        payload: true,
      },
    ]);
    axios
      .get(`${JOURNEYS}/${id}/report`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.REPORT_FETCHED,
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch([
          {
            type: types.REPORT_LOAD,
            payload: false,
          },
        ]);
        dispatch({
          type: 'SNACKBAR',
          payload: {
            message: 'Não foi possível carregar o relatório da jornada',
            variant: 'error',
            open: true,
          },
        });
      });
  };
};
